/** 解析 H5 签署页 URL 参数（仅 contract_id + token + api） */
export function parseSignQuery() {
  const params = new URLSearchParams(window.location.search)
  const api =
    params.get('api') ||
    params.get('domain') ||
    params.get('api_domain') ||
    ''
  return {
    contractId:
      params.get('contract_id') || params.get('contractId') || params.get('id') || '',
    token: params.get('token') || params.get('tokenkey') || '',
    api: decodeParam(api).replace(/\/$/, ''),
  }
}

function decodeParam(val) {
  if (!val) return ''
  try {
    return decodeURIComponent(val)
  } catch (e) {
    return val
  }
}

export function buildApiPaths(apiBase) {
  const base = (apiBase || '').replace(/\/$/, '')
  return {
    detailUrl: (id) => `${base}/make_rider/v1/sign_contract/detail/${id}`,
    completeUrl: `${base}/make_rider/v1/sign_contract/complete`,
  }
}

export function formatAuthHeader(token) {
  const raw = (token || '').trim()
  if (!raw) return ''
  return /^Bearer\s/i.test(raw) ? raw : `Bearer ${raw}`
}

/** 资源地址：支持相对路径、绝对 URL、data/blob */
export function formatFileUrl(apiBase, url) {
  if (!url) return ''
  const str = String(url).trim()
  const lower = str.toLowerCase()
  if (
    lower.indexOf('data:') === 0 ||
    lower.indexOf('blob:') === 0 ||
    lower.indexOf('http://') === 0 ||
    lower.indexOf('https://') === 0
  ) {
    return str
  }
  const base = (apiBase || '').replace(/\/$/, '')
  const path = str.charAt(0) === '/' ? str : `/${str}`
  return `${base}${path}`
}

export function hasBackendSeal(sealUrl) {
  return !!(sealUrl && String(sealUrl).trim())
}

export async function fetchContractDetail(apiBase, contractId, token) {
  const { detailUrl } = buildApiPaths(apiBase)
  const response = await fetch(detailUrl(contractId), {
    method: 'GET',
    headers: {
      Authorization: formatAuthHeader(token),
      'Content-Type': 'application/json',
    },
  })
  if (!response.ok) {
    throw new Error(`合同加载失败 (${response.status})`)
  }
  const data = await response.json()
  if (data.code !== 200 || !data.data) {
    throw new Error(data.message || '获取合同失败')
  }
  return data.data
}
